import React from 'react';
import { useDropzone } from 'react-dropzone';
import { awsPostData } from "../aws/aws_integration"
import { swap } from "react-grid-dnd";
import CircularProgress from '@material-ui/core/CircularProgress';
import ImageEditorRc from 'react-cropper-image-editor';
import Popup from "reactjs-popup";
import 'cropperjs/dist/cropper.css';
import ImageResize from 'image-resize';


// this just builds the image list jsx
const _imageList = (images, imageBaseUrl, changeImageList, dragEnter,  deleteImage, dragOver) => {

    if (images.length > 0) {
        let imageUrls = Array.from(images);
        for (let i = 0; i < imageUrls.length; i++) {
            // image url can either be the image name or the full url
            // if we only have the name, we need to add the base url to it
            if (imageUrls[i].indexOf("http") === -1) {
                if (imageUrls[i] != 0) {
                    imageUrls[i] = imageBaseUrl + imageUrls[i];
                }
            }
        }
        let jsxImages = [];
        imageUrls.forEach(image => {
            if (image !== "") {
                const buttonStyle = {
                    position: "absolute",
                    top: "0%",
                    right: "0%",
                    backgroundColor: "#555",
                    color: "white",
                    fontSize: "16px",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "10px"
                }
                jsxImages.push(
                    <div
                        key={image.split("/").pop() + jsxImages.length.toString()}
                        // onDragEnd={() => changeImageList()}
                        // onDragOver={() => dragEnter(image.split("/").pop())}
                        onPointerOver={() => dragOver(image.split("/").pop())}
                        onPointerDown={() => dragEnter(image.split("/").pop())}
                        onPointerUp={() => changeImageList()}
                        style={{ height: "60px", padding: "10px", position: "relative", display: "inline-block" }}
                    >
                        <img draggable="false" className="imageDropImage" src={image} id={image.split("/").pop()} />
                        <button onClick={() => { deleteImage(image.split("/").pop()); }} style={buttonStyle}>X</button>
                    </div>
                );
            }
        });
        return jsxImages;
    }
    return [];
}

export const DropZone = props => {
    const [images, setImages] = React.useState(props.images !== null ? props.images : []);
    const [dragDrop, setDragDrop] = React.useState(["", ""]);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [imageFiles, setImageFiles] = React.useState([{ url: "test.com", name: "name" }]);
    const [isDragging, setIsDragging] = React.useState(false);

    const maxPhotos = props.maxPhotos || 100;

    // to make code more readable
    const drag = 0;
    const drop = 1;

    const _dragEnter = t => {
        if (!isDragging) { setIsDragging(true) }
        //console.log(dragDrop[drag] + "-" + dragDrop[drop])
        if (dragDrop[drag] === "") {
            setDragDrop([t, dragDrop[drop]]);
        } else {
            setDragDrop([dragDrop[drag], t]);

            let newImages = images;
            const dragIndex = newImages.indexOf(dragDrop[drag]);
            const dropIndex = newImages.indexOf(t);

            // This check is so that we don't do anything in the case where the user has just deleted an image
            if (dragIndex>=0 && dropIndex>=0) {
                // Swap the array positions :
                [newImages[dropIndex], newImages[dragIndex]] = [newImages[dragIndex], newImages[dropIndex]];
            }
            setImages(newImages);
        }
    }

    const _hoverOver = t => {

        if (isDragging) {
            //console.log(dragDrop[drag] + "-" + dragDrop[drop])
            if (dragDrop[drag] === "") {
                setDragDrop([t, dragDrop[drop]]);
            } else {
                setDragDrop([dragDrop[drag], t]);

                console.log(images.length);
                
                let newImages = images;
                const dragIndex = newImages.indexOf(dragDrop[drag]);
                const dropIndex = newImages.indexOf(t);

                // This check is so that we don't do anything in the case where the user has just deleted an image
                if (dragIndex>=0 && dropIndex>=0) {
                    // Swap the array positions :
                    [newImages[dropIndex], newImages[dragIndex]] = [newImages[dragIndex], newImages[dropIndex]];
                }
                setImages(newImages);
            }
        }
    }

    const deleteImage = (imageName) => {
        if (confirm("This will PERMANENTLY DELETE the image file.\nDo you want to proceed?")) {

            let newImages = [];

            // Delete the image from the array
            images.forEach((element) => {
                if (element !== imageName) {
                    newImages.push(element);
                }
            });

            props.updateImages(newImages);
            setImages(newImages);
        }
    }

    // this is responsible for the drag and drop image organization and adding new images
    const _changeImageList = (files) => {
        // if we have new images to add, go through here
        if (files !== undefined && files.length > 0) {
            let fileUrls = [];
            for (const file in files) {
                // make a url reference so we can edit the image later
                fileUrls.push({ url: URL.createObjectURL(files[file]), name: files[file].name });
            }

            setOpenPopup(true)
            // this will trigger the popup to open, and thus running EditImages
            setImageFiles(fileUrls)

            // else do the drag drop thing
        } else if (dragDrop[drag] !== "" && dragDrop[drop] !== "") {
            setIsDragging(false)
            setDragDrop(["", ""]);
            props.updateImages(images);
        }
    }

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop: (f) => _changeImageList(f),
        noClick: true,
        noKeyboard: true
    });

    let imageJSX = _imageList(images, props.imageBaseUrl, _changeImageList, _dragEnter, deleteImage, _hoverOver);

    const height = Math.ceil((images.length + 1) / 3) * 80;

    const buttonStyle = {
        border: "none",
        cursor: "pointer",
        position: "relative"
    }

    const blobToImage = (blob) => {
        return new Promise(resolve => {
            const url = URL.createObjectURL(blob)
            let img = new Image()
            img.onload = () => {
                URL.revokeObjectURL(url)
                resolve(img)
            }
            img.src = url
        })
    }

    const onSave = async (file, name, callback) => {
        const blob = await fetch(file)
            .then((f) => {
                console.log(f);
                return f.blob();
            })
        const image = await blobToImage(blob)

        if (image.width <= 400 || image.height <= 400) {
            alert("Your image is too small (min is 400 x 400)")
            callback();
            return;
        }

        /*const maxLength = props.maxLength || 1920;

        let resizeData = { width: image.width, height: image.height }

        // I need to ensure the image is at max, maxLength x maxLength, or 1920 x 1920
        if (image.width >= maxLength || image.height >= maxLength) {
            if (typeof props.aspectRatio === 'undefined') {
                if (image.width > image.height) {
                    const scale = maxLength/image.width;
                    resizeData.width = maxLength;
                    resizeData.height = scale*image.height;
                } else {
                    const scale = maxLength/image.width;
                    resizeData.width = scale*image.width;
                    resizeData.height = maxLength;
                }
            } else if (props.aspectRatio >= 1) {
                resizeData.width = maxLength;
                resizeData.height = resizeData.width / props.aspectRatio;
            } else {
                resizeData.height = maxLength
                resizeData.width = resizeData.height / props.aspectRatio;
            }
        }

        console.log(resizeData);

        const imageResize = new ImageResize(resizeData);

        const resizedImage = await imageResize.play(file).catch((e) => console.log(e));
        console.log(resizedImage);
        const blob = await fetch(resizedImage).then((f) => {
            console.log(f);
            return f.blob();
        });
        console.log(blob.size);*/

        awsPostData(blob, name, props.imageBaseUrl).then((r) => {
            console.log(r);
            let newImages = images;
            newImages.push(name);
            //props.updateImages(newImages);
            setImages(newImages);
            callback();
        });
    }


    const EditImages = () => {

        const [fileIndex, setFileIndex] = React.useState(imageFiles.length - 1);
        const [loading, setLoading] = React.useState(false);

        const callback = () => {
            setFileIndex(fileIndex - 1);
            setLoading(false);
        }

        if (fileIndex < 0 && !loading) {
            setOpenPopup(false)
            props.updateImages(images);
            return <div />
        }

        const supportedFileTypes = [ 'png', 'jpg', 'jpeg' ]
        var fileExtension, sanitizedFileName
        if (imageFiles[fileIndex] && imageFiles[fileIndex].name) {
            const getUuid = require('uuid-by-string');
            fileExtension = imageFiles[fileIndex].name.split('.').pop().toLowerCase();
            sanitizedFileName = `${getUuid(imageFiles[fileIndex].name)}.${fileExtension}`;
        }

        console.log(sanitizedFileName);

        return (
            <div>
                {loading
                    ? <div style={{ marginLeft: "45%" }}><CircularProgress /></div>
                    : (!supportedFileTypes.includes(fileExtension))
                        ?
                            <div>
                                <p>Image file type not supported ({fileExtension}) </p>
                                <p>Must be one of {supportedFileTypes.toString()} </p>
                                <p>Cannot upload "{imageFiles[fileIndex].name}" </p>
                                <p><button onClick={callback}>OK</button></p>
                            </div>
                        :
                            <ImageEditorRc
                                src={imageFiles[fileIndex].url}
                                //aspectRatio={props.aspectRatio}
                                guides={false}
                                style={{height: 450, width: 600}}
                                saveImage={(image) => {
                                    setLoading(true);
                                    onSave(image, sanitizedFileName ? sanitizedFileName : imageFiles[fileIndex].name, callback);
                                }}
                            />
                }
            </div>
        );
    }

    if (imageJSX.length < maxPhotos) {
        imageJSX.push(
            <div key={"popup" + imageJSX.length.toString()} style={{ padding: "10px", position: "relative", display: "inline-block" }}>
                <button onClick={open} style={buttonStyle} className="button">
                    <img draggable="false" src="https://static.thenounproject.com/png/187803-200.png" style={{ height: "60px", position: "relative" }} />
                </button>
                <Popup contentStyle={{width: "600", height: "450"}} open={openPopup} modal onClose={() => setOpenPopup(false)} closeOnDocumentClick={false}>
                    <EditImages />
                </Popup>
            </div>
        );
    }

    let width = 360;

    switch (maxPhotos) {
        case 1: width = 90; break;
        case 2: width = 180; break;
        case 3: width = 270; break;
    }

    return (
        <div {...getRootProps({ className: 'dropzone' })}
            key={props.key}
            style={{ height: height || 40, backgroundColor: "#eee", width: width }}
        >
            <input {...getInputProps()} />
            {imageJSX}
        </div>
    );
}